import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=521cd3d0&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=ts&setup=true"
export * from "./Settings.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Settings.vue?vue&type=style&index=0&id=521cd3d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521cd3d0",
  null
  
)

export default component.exports